import { useEffect, useState } from "react";
import Modal from "react-modal";

import { ModalProps } from "./modal.props";
import { CloseIconWraper, ModalBody, ModalFooter, ModalHeader, StyleScreenWidthDefault, StyleScreenWidthLarger } from "./modal.styled";
import Tooltip from "../Tooltip";



const AGModal = ({
    visible,
    toggleModal,
    footer,
    title,
    children,
    setHeight,
    bodyStyle,
    setHeightHeader,
    setMaxHeight,
    isMaxContent = false,
    toolstip,
    titleTooltip,
    styleCus,
    ...props
}: ModalProps) => {
    const handleClose = () => {
        toggleModal();
    };
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            setScreenHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const customStyles = (screenWidth > 768 && screenHeight > 430) ? StyleScreenWidthLarger(setHeight, setMaxHeight, isMaxContent) : StyleScreenWidthDefault;
    return (
        <Modal
            isOpen={visible}
            style={customStyles}
            closeTimeoutMS={100}
        >
            <ModalHeader height={setHeightHeader}>
                <div className="title flex text-[#58585B] gap-[5px]">
                    {title}
                    {toolstip && <Tooltip text={<div className="tool-tip">{titleTooltip}</div>} />}
                </div>
                <CloseIconWraper onClick={handleClose}><CloseIcon /></CloseIconWraper>
            </ModalHeader>
            <ModalBody style={bodyStyle} className="custom-scroll">
                {children}
            </ModalBody>
            {footer && <ModalFooter>
                {footer}
            </ModalFooter>
            }
        </Modal >
    );
};

export default AGModal;

const CloseIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
        <path d="M13.4998 0.0332031C6.14714 0.0332031 0.166016 6.01432 0.166016 13.367C0.166016 20.7196 6.14714 26.7007 13.4998 26.7007C20.8524 26.7007 26.8335 20.7196 26.8335 13.367C26.8335 6.01432 20.8524 0.0332031 13.4998 0.0332031ZM18.9273 17.4831L17.6148 18.7956L13.4999 14.6795L9.38374 18.7944L8.07248 17.4818L12.1874 13.367L8.07248 9.2508L9.38374 7.93829L13.4999 12.0545L17.6161 7.93829L18.9286 9.2508L14.8124 13.367L18.9273 17.4831Z" fill="#58585B" />
    </svg>
}